import {
  IntegrationChannelType,
  IntegrationViewFragment,
} from 'generated/graphql';

interface GetIsIncompleteIntegrationDataOptions {
  integrationData: IntegrationViewFragment['data'];
  channelType: IntegrationChannelType;
  isDisabledIntegration?: boolean;
}

export const getIsIncompleteIntegrationData = ({
  integrationData,
  channelType,
  isDisabledIntegration,
}: GetIsIncompleteIntegrationDataOptions) => {
  if (isDisabledIntegration) {
    return false;
  }

  switch (channelType) {
    case IntegrationChannelType.Slack:
      return integrationData.slack?.subscribedChannels?.length === 0;
    case IntegrationChannelType.Discord:
      return integrationData.discord?.subscribedChannels?.length === 0;
    case IntegrationChannelType.FileUpload:
      return Boolean(integrationData.fileUpload?.isEmpty);
    case IntegrationChannelType.FacebookPages:
      return !integrationData.facebookPages?.subscribedPage;
    case IntegrationChannelType.GoogleMyBusiness:
      return !integrationData.googleMyBusiness?.account;
    case IntegrationChannelType.Reddit:
      return !integrationData.reddit?.subreddit;
    case IntegrationChannelType.SurveyMonkey:
      return integrationData.surveyMonkey?.includedSurveys?.length === 0;
    case IntegrationChannelType.Typeform:
      return integrationData.typeform?.includedForms?.length === 0;
    case IntegrationChannelType.Qualtrics:
      return integrationData.qualtrics?.surveys.length === 0;
    case IntegrationChannelType.Gainsight:
      return integrationData.gainsight?.subscribedCategories.length === 0;
    case IntegrationChannelType.Sprig:
      return integrationData.sprig?.surveys.length === 0;
    case IntegrationChannelType.Instagram:
      return !integrationData.instagram?.subscribedInstagramHandle;
    default:
      // TODO: Add for Salesforce when BE contract is updated
      return false;
  }
};
